module.exports = __webpack_public_path__ + "img/logo-stats.f6e8bdf7.svg";